export enum ChartSetupFiltersEnum {
    dataTypes = 'dataTypes',
    dataSources = 'dataSources',
    chartTypes = 'chartTypes'
};
